module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17924/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp3.svg"